import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import 'moment-timezone';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormInput from 'components/forms/FormInput';
import FormWorkingHours from 'components/forms/FormWorkingHours';
import FormSwitchery from 'components/forms/FormSwitchery';

class ClientLocationSalesPointData extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    moment.locale(globalLocale);
  }

  componentDidMount = () => {
    const { shownIndex, data } = this.props;

    if (!data.getWorkingWeek().getReferenceDate()) {
      this.updateEntity(
        'referenceDate',
        moment('2000-01-01').toISOString(),
        ['locations', shownIndex, 'workingWeek'],
        null,
        false
      );
    }
  };

  getWeekdays = () => {
    const weekStartsWith = moment()
      .startOf('week')
      .date();
    let newDate = moment().date(weekStartsWith);
    const days = [];
    for (let i = 0; i < 7; i++) {
      days.push({
        name: moment(newDate).format('dddd'),
        isoWeekday: moment(newDate).isoWeekday(),
      });

      newDate = moment(newDate).add(1, 'days');
    }

    return days;
  };

  getIsoWorkingHours = isoWeekday => {
    const { entity, shownIndex } = this.props;
    return entity
      .getLocations()
      [shownIndex].getWorkingWeek()
      ['getIsoDay' + isoWeekday]();
  };

  render() {
    const {
      intl: { messages },
      disabled,
      data,
      shownIndex,
    } = this.props;

    return (
      <div>
        <Row>
          <Col xs={12} md={6}>
            <div className="panel panel-transparent">
              <div className="panel-body">
                <p>{messages.settings}</p>
                <div>
                  <FormSwitchery
                    name="isSalesPoint"
                    checked={data.getIsSalesPoint()}
                    value
                    label={messages.sales_point}
                    onChange={(name, value) => this.updateEntity(name, value, ['locations', shownIndex])}
                  />
                </div>

                <p className="m-t-10 form-group-title">{messages.formGroup.contact_data}</p>
                <div className="form-group-attached">
                  <FormInput
                    type="email"
                    label={messages.email}
                    name="salesPointEmail"
                    value={data.getSalesPointEmail()}
                    meta={data.getSalesPointEmailMetaInformation()}
                    validation={data.getSalesPointEmailValidationResult()}
                    onChange={(name, value) => this.updateEntity(name, value, ['locations', shownIndex])}
                    disabled={disabled}
                  />
                  <FormInput
                    label={messages.phone}
                    name="salesPointPhone"
                    value={data.getSalesPointPhone()}
                    meta={data.getSalesPointPhoneMetaInformation()}
                    validation={data.getSalesPointPhoneValidationResult()}
                    onChange={(name, value) => this.updateEntity(name, value, ['locations', shownIndex])}
                    disabled={disabled}
                  />
                </div>
              </div>
            </div>
          </Col>

          <Col xs={12} md={6}>
            <div className="panel panel-transparent">
              <div className="panel-body">
                <p className="form-group-title">{messages.formGroup.opening_hours}</p>
                <div className="form-group-attached">
                  {this.getWeekdays().map(day => {
                    return (
                      <FormWorkingHours
                        key={day.isoWeekday}
                        meta={data.getWorkingWeekMetaInformation()}
                        label={day.name}
                        value={this.getIsoWorkingHours(day.isoWeekday)}
                        timezone={this.props.timezone}
                        disabled={disabled}
                        name={'isoDay' + day.isoWeekday}
                        onChange={(name, value) =>
                          this.updateEntity(name, value, ['locations', shownIndex, 'workingWeek'])
                        }
                        referenceDate={data.getWorkingWeek().getReferenceDate()}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default injectIntl(ClientLocationSalesPointData);
